/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


/**
 * An array of the users permissionIds
 */
export enum Permissions {
    NUM_1 = 1,
    NUM_2 = 2,
    NUM_3 = 3,
    NUM_4 = 4,
    NUM_19 = 19,
    NUM_10 = 10,
    NUM_5 = 5,
    NUM_7 = 7,
    NUM_8 = 8,
    NUM_6 = 6,
    NUM_14 = 14,
    NUM_18 = 18,
    NUM_17 = 17,
    NUM_50 = 50,
    NUM_51 = 51,
    NUM_52 = 52,
    NUM_100 = 100,
    NUM_105 = 105,
    NUM_110 = 110,
    NUM_111 = 111,
    NUM_115 = 115,
    NUM_116 = 116,
    NUM_120 = 120,
    NUM_121 = 121,
    NUM_125 = 125,
    NUM_126 = 126,
    NUM_130 = 130,
    NUM_131 = 131,
    NUM_135 = 135,
    NUM_136 = 136,
    NUM_140 = 140,
    NUM_141 = 141,
    NUM_142 = 142,
    NUM_143 = 143,
    NUM_144 = 144,
    NUM_145 = 145,
    NUM_146 = 146,
    NUM_147 = 147,
    NUM_148 = 148,
    NUM_150 = 150,
    NUM_151 = 151,
    NUM_152 = 152,
    NUM_153 = 153,
    NUM_154 = 154,
    NUM_155 = 155,
    NUM_156 = 156,
    NUM_157 = 157,
    NUM_160 = 160,
    NUM_161 = 161,
    NUM_162 = 162,
    NUM_163 = 163,
    NUM_164 = 164,
    NUM_165 = 165,
    NUM_166 = 166,
    NUM_167 = 167,
    NUM_168 = 168,
    NUM_169 = 169,
    NUM_170 = 170,
    NUM_171 = 171,
    NUM_172 = 172,
    NUM_180 = 180,
    NUM_181 = 181,
    NUM_182 = 182,
    NUM_190 = 190,
    NUM_191 = 191,
    NUM_192 = 192,
    NUM_193 = 193,
    NUM_194 = 194,
    NUM_195 = 195,
    NUM_200 = 200,
    NUM_201 = 201,
    NUM_202 = 202,
    NUM_9001 = 9001,
    NUM_9002 = 9002,
    NUM_9003 = 9003,
}